import { Toolbar, IToolbar } from "./Toolbar";
import { ScrollView } from "@dhx/ts-common/ScrollView";
import { el } from "@dhx/ts-common/dom";
import { locateNode } from "@dhx/ts-common/html";
import { tooltip, Position } from "@dhx/ts-message";

export interface IProToolbar extends IToolbar {
	scrollView: ScrollView;
}

export class ProToolbar extends Toolbar implements IProToolbar {
	scrollView: ScrollView;

	constructor(element?: string | HTMLElement, config?) {
		super(element, config);
		this.scrollView = new ScrollView(() => this.getRootView());
	}

	protected _draw(element) {
		const getAriaAttrs = element => ({
			role: "toolbar",
			"aria-label": element || "",
		});

		const toolbarHeight = this.data.getLength()
			? this.data.reduce((result, item) => {
					switch (item.type) {
						case "title":
							return !result ? 20 : result;
						case "button":
							return item.size === "small" && (!result || result <= 28) ? 28 : result || 32;
						default:
							return 32;
					}
			  }, 0) + 24
			: null;

		const navBar = [
			el(
				"ul.dhx_navbar.dhx_navbar--horizontal",
				{
					"data-dhx-widget-id": this._uid,
					tabindex: 0,
					...getAriaAttrs(element),
					onclick: this._handlers.onclick,
					onmousedown: this._handlers.onmousedown,
					oninput: this._handlers.input,
					onmouseover: this._handlers.tooltip,
					_hooks: {
						didInsert: node => {
							node.el.addEventListener(
								"keyup",
								e => {
									if (e.which !== 9) {
										return;
									}
									const elem = locateNode(document.activeElement);
									if (!elem) {
										return;
									}
									const id = elem.getAttribute("data-dhx-id");
									const item = this.data.getItem(id);
									if (item?.tooltip) {
										tooltip(item.tooltip, {
											node: elem as HTMLElement,
											position: Position.bottom,
											force: true,
										});
									}
								},
								true
							);
						},
					},
				},
				this.data.map(item => this._factory(item), this.data.getRoot(), false)
			),
		];

		return el(
			"nav.dhx_widget.dhx_toolbar",
			{
				style: { height: toolbarHeight },
				class: this.config.css ? this.config.css : "",
			},
			this.scrollView && this.scrollView.config.enable
				? [].concat(this.scrollView.render(navBar))
				: navBar
		);
	}
}
